import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  TableFooter,
  Button,
  IconButton,
} from "@mui/material";
import useModalStrip from "../../../global-hooks/useModalStrip";
import { useNavigate } from "react-router-dom";
import formatDate from "../../../utils/formatDate";
import Swal from "sweetalert2";
import axios from "axios";
import { Delete, Login } from "@mui/icons-material";
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import QrCodeIcon from "@mui/icons-material/QrCode";
import Tooltip from "@mui/material/Tooltip";



const TableListData = ({ data, searchString, page, setPage, rowsPerPage, setRowsPerPage, deleteTemplate, changeTemplateStatus, handleGenerateSchoolCode }) => {
  const [localData, setLocalData] = useState(data); // Store local data to update UI
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleLogin = async (code) => {
    try {
    
     

      const response = await axios.post(`${API_BASE_URL}/school-login`, { schoolCode: code });
      if (response?.data?.status === "SUCCESS") {
        await localStorage.setItem("schoolId", response.data.formId);
        await localStorage.setItem("schoolTemplate", JSON.stringify(response.data.templateData));
        await localStorage.setItem("schoolName", JSON.stringify(response.data.templateData?.formName ?? "Teacher Dashboard"));
        window.open("/teacher/dashboard", "_blank", "noopener,noreferrer");
      } else {
        Swal.fire({ text: response?.data?.message, icon: "warning" });
      }
    } catch (error) {
      Swal.fire({ text: error?.message, icon: "warning" });
    } 
  };

  // Filter the data based on the searchString (case-insensitive search)
  useEffect(() => {
    if (searchString) {
      const filteredData = data.filter((template) =>
        template.formName.toLowerCase().includes(searchString.toLowerCase())
      );
      setLocalData(filteredData);
    } else {
      setLocalData(data);
    }
  }, [searchString, data]);

  // const currentData = localData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage); // Update the page number
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10)); // Update rows per page
    setPage(0); // Reset to the first page when rows per page changes
  };


  async function copySchoolCodeToClipboard(schoolCode, schoolName) {
    try {
      await navigator.clipboard.writeText(`
        ${window.location.origin}/teacher-login 
       
        schoolName:- ${schoolName}
        School Code:- ${schoolCode}
        `
      );
      Swal.fire({
        icon: "success",
        title: "Copied!",
        text: `School code "${schoolCode}" has been copied to clipboard.`,
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to copy school code.",
      });
    }
  }

  const handleCopy = (uniqueID) => {
    const sanitizedFormName = uniqueID?.formName.replace(/[^a-zA-Z0-9]/g, "_"); // Replace non-alphanumeric characters with underscores
    const fullURL = `${window.location.origin}/user-form/${uniqueID?.id}/${sanitizedFormName}`;

    navigator.clipboard.writeText(fullURL).then(() => {
      Swal.fire({
        icon: "success",
        title: "Copied!",
        html: `
          <p>Share this form:</p>
          <p><strong>${uniqueID?.formName}</strong></p>
          <p><a href="${fullURL}" target="_blank" style="color: #1976d2;">${fullURL}</a></p>
        `,
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: false,
      });
    }).catch((err) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to copy URL.",
      });
    });
  };

  return (
    <div style={{ maxHeight: "70vh", overflow: "auto" }}>
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow style={{ fontWeight: 'bold' }}>
                <TableCell style={{ fontWeight: 'bold' }}>Sr. No</TableCell>
                <TableCell style={{ fontWeight: 'bold', width: "30%" }}>Form Name</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Created By</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Created At</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Published At</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Urls</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {localData.map((template, index) => (
                <TableRow key={template?._id}>
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell> {/* Adjust based on pagination */}
                  <TableCell
                    onClick={() => navigate(`/user-responses/${template?.id}`)}
                    style={{
                      color: "blue",
                      cursor: "pointer",
                      textDecoration: "underline",
                      width: "30%",
                    }}
                    title={`View responses for ${template?.formName}`}
                  >
                    {template?.formName}
                  </TableCell>
                  <TableCell>{template?.creator?.name ?? "--"}</TableCell>
                  <TableCell>{formatDate(template?.createdAt)}</TableCell>
                  <TableCell>{formatDate(template?.lastPublishedAt)}</TableCell>
                  <TableCell>{template?.publishStatus}</TableCell>
                  <TableCell>
                    <Button
                      onClick={() => handleCopy(template)}
                      style={{
                        backgroundColor: "rgb(25 118 210)",
                        color: "white",
                        borderRadius: "8px",
                        padding: "10px",
                        cursor: "pointer",
                      }}
                    >
                      Copy URL
                    </Button>
                  </TableCell>
                  {/* <TableCell>
                    <IconButton edge="end" onClick={() => deleteTemplate(template?.id)}>
                      <Delete />
                    </IconButton>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={template?.isActive}      // Set the switch's position
                          // Handle the switch's state change
                          onChange={() => changeTemplateStatus(template?.id)}
                          color="primary"           // You can change the color (default, primary, secondary, etc.)
                        />
                      }
                      sx={{ marginLeft: 2 }}
                    />

                  </TableCell> */}
                  <TableCell
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      flexWrap: "wrap", // responsive on small screens
                    }}
                  >

                    <Tooltip title="Access School Dashboard">
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => handleLogin(template?.schoolCode)}
                      >
                        <Login fontSize="small" />
                      </IconButton>
                    </Tooltip>

                    {/* Generate / Copy School Code */}
                    {template?.schoolCode ? (
                      <Tooltip title="Copy School Code">
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => copySchoolCodeToClipboard(template?.schoolCode, template?.formName)}
                        >
                          <ContentCopyIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Generate School Code">
                        <IconButton
                          size="small"
                          color="success"
                          onClick={() => handleGenerateSchoolCode(template)}
                        >
                          <QrCodeIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}


                    {/* Delete */}
                    <Tooltip title="Delete">
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => deleteTemplate(template?.id)}
                      >
                        <Delete fontSize="small" />
                      </IconButton>
                    </Tooltip>

                    {/* Status Switch */}
                    <FormControlLabel
                      control={
                        <Switch
                          checked={template?.isActive}
                          onChange={() => changeTemplateStatus(template?.id)}
                          size="small"
                          color="primary"
                        />
                      }
                      sx={{ ml: 1 }}
                    />
                  </TableCell>

                </TableRow>
              ))}
            </TableBody>
            {/* <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  count={localData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter> */}
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

export default TableListData;
